import type { Transaction } from "@rocicorp/zero";
import { zql } from "../zql";

export namespace Vehicles {
	/**
	 * This function is used to clean up vehicle assignments from crews so that there are no duplicate
	 * vehicle assignments.
	 * @param tx
	 * @param planId
	 * @param vehicleId
	 */
	/**
	 * Finds the crew by ID and deletes its current vehicle assignment, if one exists.
	 *
	 * @param tx - The Zero transaction.
	 * @param crewId - The ID of the crew whose vehicle assignment should be removed.
	 */
	export async function cleanCurrentCrewVehicleAssignment(tx: Transaction, crewId: string) {
		const crew = await tx.run(
			zql.crews
				.where("id", "=", crewId)
				.related("vehicleAssignment", (vehicleAssignment) => vehicleAssignment.one())
				.one(),
		);
		if (crew?.vehicleAssignment) {
			await tx.mutate.vehicleAssignments.delete({ id: crew.vehicleAssignment.id });
		}
	}

	export async function cleanVehicleAssignments(
		tx: Transaction,
		planId: string,
		vehicleId: string,
	) {
		const currentCrews = await tx.run(
			zql.crews
				.where("planId", "=", planId)
				.related("vehicleAssignment", (vehicleAssignment) =>
					vehicleAssignment.where("vehicleId", "=", vehicleId).one(),
				),
		);

		for (const crew of currentCrews) {
			if (crew.vehicleAssignment) {
				await tx.mutate.vehicleAssignments.delete({ id: crew.vehicleAssignment.id });
			}
		}

		const currentVehicleAssignmentPlans = await tx.run(
			zql.vehicleAssignmentsPlan.where("planId", "=", planId),
		);

		for (const cvap of currentVehicleAssignmentPlans) {
			if (cvap.vehicleId !== vehicleId) continue;
			await tx.mutate.vehicleAssignmentsPlan.delete({ id: cvap.id });
		}
	}
}
